import { Model } from '@/services/api/lib'

export class Shipment extends Model {
  resource () {
    return 'shipments'
  }

  defaults () {
    return {
      carrier: '',
      tracking_number: '',
      notes: '',
      items: []
    }
  }

  validations () {
    return {
      'carrier': 'required|string',
      'tracking_number': 'required|string',
      'notes': 'string',
      'items': 'required|min:1|array',
      'items.*.item_id': 'required|string',
      'items.*.quantity': 'required|number|min:0'
    }
  }
}
